import type { HttpAdapter } from "../../core/adapters/axios.adapter"

export interface ReportDO {
    englishURL: string
    frenchURL: string
    germanURL: string
}


export class ReportService {
    constructor(private webflowAdapter: HttpAdapter) {
    }

    async get(slug: string):Promise<ReportDO> {
        const response = await this.webflowAdapter.get(`content/reports/${slug}`)
        return response.data
    }
}